// extracted by mini-css-extract-plugin
module.exports = {"background":"bb_d6","values":"bb_fg"};